const getPlatform = () => {
  if (typeof window !== 'undefined') {
    const isApp = window.location.hostname.includes('app.shab.ir');
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    if (isApp) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const browser = /safari|chrome/.test(userAgent);
      const ios = /iphone|ipod|ipad/.test(userAgent);
      const isWebView = document.referrer?.includes('android-app://') || window.navigator.userAgent.includes('wv') || window.navigator.userAgent.includes('WebView') || isStandalone;
      if (isWebView || ios && !browser) {
        return 'app';
      } else {
        return 'web';
      }
    } else {
      if (isStandalone) {
        return 'pwa';
      } else {
        return 'web';
      }
    }
  } else {
    return 'server';
  }
};
export default getPlatform;